import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const concatAndDeDuplicateObjects = (p, ...arrs) =>
  []
    .concat(...arrs)
    .reduce(
      (a, b) => (!a.filter(c => b[p] === c[p]).length ? [...a, b] : a),
      [],
    );

export const hexToRgb = (hex, opacity = 1) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? 'rgba(' +
        parseInt(result[1], 16) +
        ',' +
        parseInt(result[2], 16) +
        ',' +
        parseInt(result[3], 16) +
        ',' +
        opacity +
        ')'
    : null;
};

export const formatValue = (type, value) => {
  value = value ? value : 0;
  switch (type) {
    case 'integer':
      return Math.round(parseFloat(value));

    case 'decimal':
      return parseFloat(value).toFixed(1);

    case 'money':
      return parseFloat(value).toFixed(2);

    case 'fraction':
      const fractions = [
        {
          decimal: 0.25,
          fraction: '1/4',
        },
        {
          decimal: 0.5,
          fraction: '1/2',
        },
        {
          decimal: 0.75,
          fraction: '3/4',
        },
      ];
      let foundFraction = fractions.find(o => o.decimal === parseFloat(value));
      return foundFraction ? foundFraction.fraction : value;

    case 'sizes':
      const sizes = [
        {
          decimal: 0,
          size: 'no',
        },
        {
          decimal: 1,
          size: 'small',
        },
        {
          decimal: 2,
          size: 'medium',
        },
        {
          decimal: 3,
          size: 'large',
        },
      ];
      let foundSize = sizes.find(o => o.decimal === parseFloat(value));
      return foundSize ? foundSize.size : value;

    default:
      return value;
  }
};

export const STOCK = [
  {
    key: 'hours',
    title: 'Hours Worked',
    preunit: ' ',
    unit: 'hrs',
    format: 'decimal',
    options: [
      // 0,
      0.5, 1.0, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9,
      9.5, 10,
    ],
  },
  {
    key: 'miles',
    title: 'Miles',
    preunit: ' ',
    unit: 'mi',
    format: 'integer',
    options: [...Array(41)].map((_, i) => 5 * i),
  },
  {
    key: 'emulsion',
    title: 'Emulsion',
    preunit: ' ',
    unit: 'lt',
    format: 'integer',
    options: [0, 1, 2, 3, 4, 5],
  },
  {
    key: 'primer',
    title: 'Primer',
    preunit: ' ',
    unit: 'lt',
    format: 'fraction',
    options: [0, 0.5, 2, 3, 4, 5],
  },
  {
    key: 'undercoat',
    title: 'Undercoat',
    preunit: ' ',
    unit: 'lt',
    format: 'fraction',
    options: [0, 0.5, 2, 3, 4, 5],
  },
  {
    key: 'gloss',
    title: 'Gloss',
    preunit: ' ',
    unit: 'lt',
    format: 'fraction',
    options: [0, 0.5, 2, 3, 4, 5],
  },
  {
    key: 'stain',
    title: 'Stain',
    preunit: ' ',
    unit: 'lt',
    format: 'fraction',
    options: [0, 0.5, 2, 3, 4, 5],
  },
  {
    key: 'screws',
    title: 'Screws',
    preunit: ' ',
    unit: ' box',
    format: 'fraction',
    options: [0, 0.25, 0.5, 1],
  },
  {
    key: 'mastic',
    title: 'Mastic',
    preunit: ' ',
    unit: ' tube(s)',
    format: 'fraction',
    options: [0, 0.5, 1, 2, 3, 4, 5],
  },
  {
    key: 'caulk',
    title: 'Caulk',
    preunit: ' ',
    unit: ' tube(s)',
    format: 'fraction',
    options: [0, 0.5, 1, 2, 3, 4, 5],
  },
  {
    key: 'filler',
    title: 'Filler',
    preunit: ' ',
    unit: ' tub',
    format: 'sizes',
    options: [
      0, //'no',
      1, //'small',
      2, //'medium',
      3, //'large',
    ],
  },
  {
    key: 'sundries',
    title: 'Sundries',
    preunit: ' £',
    unit: ' ',
    format: 'money',
    options: [0, 5],
  },
];
